import { Spin } from "antd";
import useCustomerBookingsInfo from "hooks/useCustomerBookingsInfo";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "redux/actions/app.actions";
import { setFetchingCustomerBookings } from "redux/actions/customerInfo.actions";
import {
  getCustomerNoShowBookings,
  getCustomerTotalBookings,
  getCustomerUpcomingBookings,
} from "services/booking.service";

export default function CustomerBookingCounts({
  customerId,
  onAppointmentTypeClick,
  customer
}) {
  // const refreshCustomerBookingData = useCustomerBookingsInfo(customerId, false);

  const dispatch = useDispatch();
  // const { customerInfo } = useSelector((state) => state);

  const { totalOrdersCount, pendingOrdersCount, noShowsCount, isFetching } =
    customer;

  return (
    <div
      style={{
        padding: "12px 0px",
        paddingBottom: 16,
        borderBottom: "2px solid #EFF1F4",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        fontFamily: "tradeGothic",
        fontWeight: "normal",
        fontSize: 16,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {isFetching ? (
          <Spin />
        ) : (
          <p style={{ fontSize: 30, margin: 0 }}>
            {totalOrdersCount ?? 0}
          </p>
        )}

        <p
          style={{
            textAlign: "center",
            margin: 0,
            lineHeight: 1.2,
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={async () => {
            onAppointmentTypeClick(0);
            dispatch(setFetchingCustomerBookings(true));
            dispatch(getCustomerTotalBookings(customerId)).finally(() => {
              dispatch(setFetchingCustomerBookings(false));
            });
          }}
        >
          Total Bookings
        </p>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {isFetching ? (
          <Spin />
        ) : (
          <p style={{ fontSize: 30, margin: 0 }}>
            {pendingOrdersCount ?? 0}
          </p>
        )}
        <p
          style={{
            textAlign: "center",
            margin: 0,
            lineHeight: 1.2,
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={async () => {
            onAppointmentTypeClick(1);

            dispatch(setFetchingCustomerBookings(true));
            dispatch(getCustomerUpcomingBookings(customerId)).finally(() => {
              dispatch(setFetchingCustomerBookings(false));
            });

          }
          }
        >
          Upcoming Appointments
        </p>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {isFetching ? (
          <Spin />
        ) : (
          <p style={{ fontSize: 30, margin: 0 }}>
            {noShowsCount ?? 0}
          </p>
        )}
        <p
          style={{
            textAlign: "center",
            margin: 0,
            lineHeight: 1.2,
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => {
            onAppointmentTypeClick(3)
            dispatch(setFetchingCustomerBookings(true));
            dispatch(getCustomerNoShowBookings(customerId)).finally(() => {
              dispatch(setFetchingCustomerBookings(false));
            });
          }
          }
        >
          No Shows
        </p>
      </div>
    </div>
  );
}
